import React, { memo } from "react";
import styled from "styled-components/macro";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface FilterItemProps {
  text: string;
  isActive: boolean;
  setActive: () => void;
}

const FilterItem: React.FC<FilterItemProps> = ({ text, isActive, setActive }) => {
  return (
    <FilterItemContainer onClick={setActive}>
      <Checkbox>
        {isActive ? <MdCheckBox className="checkbox-checked" /> : <MdCheckBoxOutlineBlank className="checkbox" />}
      </Checkbox>
      <DefaultText style={{ letterSpacing: "1px" }}>{text}</DefaultText>
    </FilterItemContainer>
  );
};

const FilterItemContainer = styled.div`
  cursor: pointer;
  padding: 5px 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
`;
FilterItemContainer.displayName = "FilterItemContainer";
const Checkbox = styled.div`
  display: flex;
  align-items: center;
  padding-right: 5px;

  .checkbox {
    fill: ${colors.dark_gray};
    width: 18px;
    height: 18px;

    &:hover {
      fill: ${colors.light_blue};
    }
  }

  .checkbox-checked {
    width: 18px;
    height: 18px;
    fill: ${colors.light_blue};
  }
`;
Checkbox.displayName = "Checkbox";

export default memo(FilterItem);
